import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import { handleAuthFailure } from '@/utils/authRedirect';

/**
 * Standard Amplify v2 Auth Handler
 * Provides utility methods for auth operations
 * Note: Hub events are handled by the auth store to avoid loops
 */
class AmplifyAuthHandler {
  private isInitialized = false;

  /**
   * Initialize auth handler
   */
  public initialize(): void {
    if (this.isInitialized) return;
    
    this.isInitialized = true;
    console.log('[AmplifyAuthHandler] Initialized');
  }

  /**
   * Handle token refresh failure
   */
  public async handleTokenRefreshFailure(): Promise<void> {
    console.warn('[AmplifyAuthHandler] Token refresh failed, logging out user');
    handleAuthFailure('Token refresh failed');
  }

  /**
   * Check if user is authenticated
   */
  public async isAuthenticated(): Promise<boolean> {
    try {
      const session = await fetchAuthSession();
      return !!session.tokens?.idToken;
    } catch (error) {
      console.error('[AmplifyAuthHandler] Error checking authentication:', error);
      return false;
    }
  }

  /**
   * Force sign out
   */
  public async forceSignOut(): Promise<void> {
    try {
      await signOut();
      handleAuthFailure('Forced sign out');
    } catch (error) {
      console.error('[AmplifyAuthHandler] Error during force sign out:', error);
      // Force redirect even if sign out fails
      handleAuthFailure('Sign out failed');
    }
  }
}

// Export singleton instance
export const amplifyAuthHandler = new AmplifyAuthHandler(); 